import type { ReactNode } from 'react';
import styles from './AuthLayout.module.css';

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * Shared layout for authentication pages (login, register, forgot-password).
 *
 * Desktop: split layout with branding panel on the left and form content on the right.
 * Mobile: only the form content is shown (branding panel hidden).
 *
 * Uses theme CSS custom properties for colors (primary green, secondary dark blue).
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className={styles.layout}>
      <aside className={styles.brandingPanel} aria-hidden="true">
        <div className={styles.brandingContent}>
          <div className={styles.logoArea}>
            <span className={styles.logoIcon} aria-hidden="true">
              +
            </span>
          </div>
          <h1 className={styles.appName}>
            CRM<span className={styles.appNameAccent}>Clinica</span>
          </h1>
          <p className={styles.tagline}>
            Gestão inteligente para sua clínica. Simplifique agendamentos, gerencie pacientes e
            otimize sua rotina.
          </p>
          <div className={styles.features}>
            <div className={styles.featureItem}>
              <span className={styles.featureCheck} aria-hidden="true">
                &#10003;
              </span>
              <span>Agendamento online 24/7</span>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.featureCheck} aria-hidden="true">
                &#10003;
              </span>
              <span>Gestão completa de pacientes</span>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.featureCheck} aria-hidden="true">
                &#10003;
              </span>
              <span>Lembretes automáticos</span>
            </div>
          </div>
        </div>
      </aside>
      <main className={styles.formPanel}>
        <div className={styles.formContainer}>{children}</div>
      </main>
    </div>
  );
}
